import {QueryFunctionContext, useQuery} from "@tanstack/react-query"
import axios from "axios"
export interface Value {
    referenceKey: string
    value: string
    localeKey: string | null
}
interface AutomationFormActionValuesDataResponse {
    AVAILABLE_ACTION_FIELD_VALUES: Array<Value>
}

export type OnAutomationFormActionValuesDataSuccess = (data: any) => void
export const DEFAULT_AUTOMATION_FORM_ACTION_VALUES_DATA = {
    AVAILABLE_ACTION_FIELD_VALUES: [],
} as AutomationFormActionValuesDataResponse

async function fetchAutomationFormActionValuesData({ queryKey }: QueryFunctionContext<string[]>) {

    const [fullQueryKey, actionType] = queryKey;
    if (actionType === undefined) {
        return DEFAULT_AUTOMATION_FORM_ACTION_VALUES_DATA;
    }

    const { data } = await axios.get<AutomationFormActionValuesDataResponse>(fullQueryKey)
    return data
}

const AUTOMATION_FORM_ACTION_VALUES_DATA_QUERY = `/admin/action/automation/admin/action/field`
interface UseAutomationFormActionValuesDataQueryProps {
    onSuccess: OnAutomationFormActionValuesDataSuccess
}
export default function useAutomationFormActionValuesDataQuery(
    actionType: string, {
    onSuccess,
}: UseAutomationFormActionValuesDataQueryProps) {
    const fullQueryKey = `${AUTOMATION_FORM_ACTION_VALUES_DATA_QUERY}/${actionType}/values`
    return useQuery<AutomationFormActionValuesDataResponse>({
        queryKey: [fullQueryKey, actionType],
        onSuccess,
        queryFn: fetchAutomationFormActionValuesData,
    })
}
